import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import img1 from "../assets/img/bandeau.jpg";


export const FAQ = () => {

  const [open, setOpen] = useState(new Array(5).fill(false)); 

  const toggleQuestion = (index) => {
    const newOpen = [...open];
    newOpen[index] = !newOpen[index];
    setOpen(newOpen);
  };


  return (
    <>    <div className="banner-titre-container">
      <img src={img1} className="back-img" />
      <div className='over-banner center-content'>
        <div className='info-banner'>
          <h1 className='banner-title'> FAQ : réponses à vos questions ...</h1>
        </div>
      </div>
    </div>

      <div className='single-container side-space bottom-space faq-background-color top-space-margin' >

        <div>

          <h4 className='faq-titre-main'>
            Les questions les plus fréquentes :
          </h4>
          <div className='faq-container'>

            <Accordion >

              <Accordion.Item eventKey="0">
                <Accordion.Header className="custom-accordion-button">Que signifie 'Lumière à donner' ?</Accordion.Header>
                <Accordion.Body>
                  "Une seule bougie permet d'allumer de nombreuses autres. Lumière et bonheur s'amplifient dès que nous les partageons ..." <br /><br />
                  Tout ce qui vit est <strong>vibration</strong>. Plus elle est <strong>élevée</strong>, plus il s'en dégage de la <strong>Lumière</strong>. Au fur et à mesure que l'être humain accroît sa conscience et sa vibration, son esprit devient plus clair, son regard plus lumineux. La Lumière, c'est la face visible de l'Amour. Amour et Lumière peuvent tout transcender : ensemble, ils oeuvrent à travers nos corps physique, émotionnel, mental et spirituel. <br /><br />
                  Les <strong>Guides</strong> de Lumière représentent des <strong>fréquences élevées d'Amour-Lumière</strong>. C'est à travers un relais comme un Channel (Canal) que leurs vibrations se communiquent aux êtres humains. Le Channel reçoit la Lumière et transmet ses propriétés bienfaisantes sous forme de mots, d'images et d'énergies qu'il communique en toute neutralité  à la personne en  demande de compréhension, de réconfort, d'éveil. L' âme  (notre part spirituelle) se nourrit et évolue avec l'Amour et la Lumière. En tant que Channel Spirituel ayant le don de canaliser la Lumière pour la retransmettre, j'ai naturellement  intitulé mon site <em>'Lumière à donner'.</em>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>Dois-je pratiquer une religion ou être croyant(e) pour bénéficier d'une séance de Channeling ou de Méditation  ?</Accordion.Header>
                <Accordion.Body>
                  Il n'y a aucun prérequis pour bénéficier de mes séances. Seul compte votre désir sincère de travailler sur vous-même et d'évoluer.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Combien de séances de Channeling faut-il pour 'aller mieux' et voir des changements ?</Accordion.Header>
                <Accordion.Body>
                  Cela dépend de la personne, de sa capacité à intégrer l'Energie Amour-Lumière et aussi de ses exigences d'âme. Certaines personnes se satisferont de l'apaisement, des réponses et des clefs reçus en une seule séance. D'autres ressentiront l'envie de poursuivre leur travail intérieur lors de séances régulières. Dans ce cas, il est recommandé de respecter un temps d'intégration de 6 à 8 semaines environ. Soyez à l'écoute de votre  intuition pour déterminer le rythme des séances qui vous convient.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Combien de temps dure une séance ?</Accordion.Header>
                <Accordion.Body>
                  Les séances durent entre 1h (méditation) et 1h30-2h (channeling). A cela s'ajoute  un temps d'échange de quinze à trente minutes.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header> Un travail spirituel ou énergétique peut-il influer ma vie ? Si oui, comment ?</Accordion.Header>
                <Accordion.Body>
                  L'être humain est un microcosme qui vit dans un macrocosme. Lorsque humain n'est pas conscient (de son grand potentiel), il est influencé par son environnement (médias, société, famille, amis
                  etc). Mais lorsqu'il développe sa conscience, il libère ses potentiels ignorés et endormis et il devient acteur de sa vie.
                  Donc oui, un travail spirituel et énergétique développe force,  vision et sagesse pour prendre les 'bonnes' décisions et influer sur notre vie.
                </Accordion.Body>
              </Accordion.Item>

            </Accordion>
          </div>


          <h5 className='faq-titre'>
            Si vous avez d'autres questions, n'hesitez pas à me contacter :
          </h5>

          <div className='bouton-rectangle-container'>
            <Link to={'/contact'} className='bouton-rectangle-music'>
              Me contacter
            </Link>
          </div>

        </div>
      </div>



    </>
  );
}

